import { Nullable } from "@core/domain/types/nullable.type";
import { EntityApiKeysRepository } from "@entity-api-keys/data/repositories/entity-api-keys.repository";
import { EntityApiKey } from "@entity-api-keys/domain/models/entity-api-key.model";
import { inject, injectable } from "inversify";

@injectable()
export class GetEntityApiKeyByIdUseCase {
    constructor(
        @inject(EntityApiKeysRepository)
        private readonly repository: EntityApiKeysRepository,
    ) {}

    async execute(id: number): Promise<Nullable<EntityApiKey>> {
        const result = await this.repository.getById(id);
        return result.fold(
            () => null,
            (key) => key,
        );
    }
}
